import React from 'react';
import { painPoints } from '../data/kit';
export function PainPointsSection() {
  return <section className="py-20 px-4 bg-brand-creamAlt" data-id="element-96" data-mp="2hsae1j41nez9">
      <div className="max-w-3xl mx-auto text-center" data-id="element-97" data-mp="2htlk5pkyoytj">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-98" data-mp="2wpb5rmm8j9xq">
          ¿Te reconocés en estas escenas?
        </h2>
        <p className="text-brand-gray mb-12" data-id="element-99" data-mp="2rodhcsamtjns">
          Si respondés que sí a alguna — este kit es para vos
        </p>

        <ul className="space-y-4 mb-12" data-id="element-100" data-mp="35nd2vr2ulifq">
          {painPoints.map((point, i) => <li key={point} className="bg-white rounded-2xl p-6 shadow-sm flex items-center gap-5 text-left border border-brand-creamDark/50" data-id="element-101" data-mp="30qcydklncnqq" data-mpi={i}>
              <span aria-hidden="true" className="font-serif font-bold text-2xl text-brand-terracotta/60 shrink-0 w-8 text-center" data-id="element-102" data-mp="3agy5jwfdz0l9">
                {i + 1}
              </span>
              <span className="text-brand-text font-medium md:text-lg" data-id="element-103" data-mp="3kcj2vh9ifcoo">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="text-xl md:text-2xl font-serif italic text-brand-green font-bold" data-id="element-104" data-mp="wxeiipxubixi">
          Y vos merecés mucho más que eso →
        </p>
      </div>
    </section>;
}